import Popover from 'trunks/vue/admin/components/libs/popover.js';

const ControlableFieldsPopover = {
  components: {
    popover: Popover
  },

  props: {
    customClass: String,

    editing: Boolean,

    controlableFields: {
      type: Array,
      default: function() {
        return [];
      }
    },

    possibleFields: {
      type: Array,
      default: function() {
        return [];
      }
    },

    fieldIds: Array,

    valid: Boolean
  },

  template: `
    <div :class="customClass">
      <popover customClass='logic-controlable-fields'
               v-if='editing'
               :caret='false'
               type='select'
               position='bottom left'
               @afterBackdropClose='popoverBackdropClosed'
               size='large'>
        <button class="outlined btn-info btn-small" slot='trigger'>设置显示字段</button>
        <template slot='content'>
          <div class="list">
            <div v-for='_field in controlableFields' :key='_field.id'>
              <label class="list-item">
                <div class="content">
                  <span v-if='_field.detail_id'>Q{{ _field.detail.position + 1 }}-{{ _field.position + 1 }}</span>
                  <span v-else>Q{{ _field.position + 1 }}</span>
                  <span>&nbsp;{{ _field.title }}</span>
                </div>
                <span class="tip">
                  <input type="checkbox"
                          :checked='_checkControledField(_field)'
                          hidden='true'
                          @change='toggleControlField($event, _field)'>
                  <i class="slp-check"></i>
                  <i class="slp-empty"></i>
                </span>
              </label>
              <div class="list detail-list" v-if='_field.type === "Field::Detail"'>
                <label class="list-item" v-for='__field in _field.children'>
                  <div class="content">
                    <span>Q{{ _field.position + 1 }}-{{ __field.position + 1 }}</span>
                    <span>&nbsp;{{ __field.title }}</span>
                  </div>
                  <span class="tip">
                    <input type="checkbox"
                            :checked='_checkControledField(__field)'
                            hidden='true'
                            @change='toggleControlField($event, __field)'>
                    <i class="slp-check"></i>
                    <i class="slp-empty"></i>
                  </span>
                </label>
              </div>
            </div>
          </div>
        </template>
      </popover>
      <div class='controled-item list' v-html='_getControledFieldsInfo()'></div>
    </div>
  `,

  methods: {
    toggleControlField: function(event, field) {
      this.$emit('toggleControlField', event, field);
    },

    popoverBackdropClosed: function(event) {
      this.$emit('popoverBackdropClosed', event);
    },

    _getControledFieldsInfo: function() {
      var sorted_fields;

      sorted_fields = _.chain(this.fieldIds)
        .map((id) => this._findFieldById(id))
        .compact()
        .map((field) => {
          if (field.detail_id) {
            field._position = field.detail.position + (field.position + 1) / (field.detail.children.length + 1);
          } else {
            field._position = field.position;
          }
          return field;
        })
        .sortBy('_position')
        .value();

      return _.map(sorted_fields, (field) => {
        var class_name, text;

        class_name = !this.valid ? 'list-item error-text' : 'list-item';
        text = field.detail_id ? `Q${field.detail.position + 1}-${field.position + 1} ${field.title}` : `Q${field.position + 1} ${field.title}`;
        return `<div class='${class_name}'>${text}</div>`;
      }).join('');
    },

    _findFieldById: function(id) {
      var field, i, len, result;

      for (i = 0, len = this.possibleFields.length; i < len; i++) {
        field = this.possibleFields[i];
        if (field.id === id) {
          return field;
        }
        if (field.type === 'Field::Detail') {
          result = _.find(field.children, (child) => child.id === id);
          if (result) {
            return result;
          }
        }
      }
    },

    _checkControledField: function(field) {
      return _.contains(this.fieldIds, field.id);
    }
  }
};

export default ControlableFieldsPopover;
